import type { MedicationProduct } from '../shared';

export const insulinProducts: MedicationProduct[] = [
    {
        description: 'HumalogU-200 Solution Pen-injector',
        dosageForm: 'SOPN',
        formLabel: '',
        packageSizeUnit: 'ML',
        ndcs: [{ ndc: '00002820827', packageQuantity: 1 }],
        pricing: {},
    },
    {
        description: 'LyumjevU-100 Solution Cartridge',
        dosageForm: 'SOCT',
        formLabel: '',
        packageSizeUnit: 'ML',
        ndcs: [{ ndc: '00002772605', packageQuantity: 1 }],
        pricing: {},
    },
    {
        description: 'LyumjevU-100 Solution Cartridge',
        dosageForm: 'SOCT',
        formLabel: '',
        packageSizeUnit: 'ML',
        ndcs: [{ ndc: '00002835105', packageQuantity: 1 }],
        pricing: {},
    },
];
